document.addEventListener("DOMContentLoaded", function () {
	const bioButtons = document.querySelectorAll(".profile-tile .staff-content .btn-bio");
	const closeButtons = document.querySelectorAll(".btn-bio-close");
	const overlayBG = document.querySelector(".overlay-bg");

	bioButtons.forEach((button) => {
		button.addEventListener("click", function () {
			document.querySelectorAll(".profile-tile .staff-bio").forEach((bio) => {
				bio.classList.remove("active");
			});

			const profileTile = button.closest(".profile-tile");
			const staffBio = profileTile.querySelector(".staff-bio");

			if (staffBio) {
				staffBio.classList.add("active");
				overlayBG.classList.add("active");
			}
		});
	});

	closeButtons.forEach((button) => {
		button.addEventListener("click", function () {
			document.querySelectorAll(".profile-tile .staff-bio").forEach((bio) => {
				bio.classList.remove("active");
				overlayBG.classList.remove("active");
			});
		});
	});

	overlayBG.addEventListener("click", function () {
		document.querySelectorAll(".profile-tile .staff-bio").forEach((bio) => {
			bio.classList.remove("active");
			overlayBG.classList.remove("active");
		});
	});
});
